export default async () => {
  const localModules = {
  "./env/starry-connect.environment.js": () => import("./env/starry-connect.environment.js"),
  "./env/search-container.environment.js": () => import("./env/search-container.environment.js"),
  "./env/network-container.environment.js": () => import("./env/network-container.environment.js"),
  "./env/line-test-webgl.environment.js": () => import("./env/line-test-webgl.environment.js"),
  "./env/gradient-webgl.environment.js": () => import("./env/gradient-webgl.environment.js"),
  "./components/ui-strings.component.js": () => import("./components/ui-strings.component.js"),
  "./components/ui-strings-data.component.js": () => import("./components/ui-strings-data.component.js"),
  "./components/starry-connect.component.js": () => import("./components/starry-connect.component.js"),
  "./components/sections.component.js": () => import("./components/sections.component.js"),
  "./components/search-container.component.js": () => import("./components/search-container.component.js"),
  "./components/scroll-proxy.component.js": () => import("./components/scroll-proxy.component.js"),
  "./components/scroll-handler.component.js": () => import("./components/scroll-handler.component.js"),
  "./components/network-container.component.js": () => import("./components/network-container.component.js"),
  "./components/network-category.component.js": () => import("./components/network-category.component.js"),
  "./components/network-case.component.js": () => import("./components/network-case.component.js"),
  "./components/menu.component.js": () => import("./components/menu.component.js"),
  "./components/matrix.component.js": () => import("./components/matrix.component.js"),
  "./components/line-test-webgl.component.js": () => import("./components/line-test-webgl.component.js"),
  "./components/header.component.js": () => import("./components/header.component.js"),
  "./components/header-container.component.js": () => import("./components/header-container.component.js"),
  "./components/gradient-webgl.component.js": () => import("./components/gradient-webgl.component.js"),
  "./components/footer.component.js": () => import("./components/footer.component.js"),
  "./components/content-container.component.js": () => import("./components/content-container.component.js"),
  "./components/connect-container.component.js": () => import("./components/connect-container.component.js"),
  "./components/case-story-container.component.js": () => import("./components/case-story-container.component.js")
};

  for (const path in localModules) {
    const filename = path.split("/").at(-1);

    if (!filename.startsWith("_")) {
      await localModules[path]();
    }
  }
};
